import axios from 'axios';
import Producto from '@/models/Producto';
import Ocompra from '@/models/Ocompra';
import moment from 'moment';
function defaultState() {
	return {
		productos: [],
		carrito: [],
		loadingcarrito: false,
		idcarrito: 0,
		totalpedido: 0,
		total: 0,
		cpago: null,
		fecha_entrega: null,
		conimpuesto: null,
		detallepedido: '',
		importes: [],
		cpagos: [],
		ordenespendientes: [],
		ordenesaprobados: [],
		ordenesaplicados: [],
		unegocio: [],
		familia: [],
		subfamilia: [],
		presentacion: [],
		rubro: [],
		subrubro: [],
		linea: [],
		marca: [],
	};
}
const state = defaultState();
const mutations = {
	setLoadingCarrito(state: { loadingcarrito: boolean }, loading: boolean) {
		state.loadingcarrito = loading;
	},
	setProductos(state: { productos: Producto[] }, productos: Producto[]) {
		state.productos = productos;
	},
	setCarrito(state, carrito) {
		state.carrito = carrito;
	},
	setIdcarrito(state: { idcarrito: number }, idcarrito: number) {
		idcarrito = idcarrito ? idcarrito : 0;
		state.idcarrito = idcarrito;
	},
	setTotalPedidos(state: { totalpedido: number }, total: number) {
		state.totalpedido = total;
	},
	setCpago(state: { cpago: number }, cpago: number) {
		state.cpago = cpago;
	},
	setCpagos(state: { cpagos: number }, cpagos: number) {
		state.cpagos = cpagos;
	},
	setFechaEntrega(state, fecha) {
		state.fecha_entrega = fecha;
	},
	setConImpuesto(state, conimpuesto) {
		state.conimpuesto = conimpuesto;
	},
	setDetallePedido(state: { detallepedido: string }, detalle: string) {
		state.detallepedido = detalle;
	},
	setImportes(state: { importes: number }, importes: number) {
		state.importes = importes;
	},
	setOrdenesPendientes(state: { ordenespendientes: Ocompra[] }, ordenespendientes: Ocompra | Ocompra[]) {
		!Array.isArray(ordenespendientes) ? state.ordenespendientes.push(ordenespendientes) : (state.ordenespendientes = []);
	},
	setOrdenesAprobados(state: { ordenesaprobados: Ocompra[] }, ordenesaprobados: Ocompra | Ocompra[]) {
		!Array.isArray(ordenesaprobados) ? state.ordenesaprobados.push(ordenesaprobados) : (state.ordenesaprobados = []);
	},
	setOrdenesAplicados(state: { ordenesaplicados: Ocompra[] }, ordenesaplicados: Ocompra | Ocompra[]) {
		!Array.isArray(ordenesaplicados) ? state.ordenesaplicados.push(ordenesaplicados) : (state.ordenesaplicados = []);
	},
	setTotal(state: { total: number }, total: number) {
		state.total = total;
	},
	setUnegocio(state: { unegocio: number }, unegocio: number) {
		state.unegocio = unegocio;
	},
	setFamilia(state: { familia: number }, familia: number) {
		state.familia = familia;
	},
	setSubfamilia(state: { subfamilia: number }, subfamilia: number) {
		state.subfamilia = subfamilia;
	},
	setPresentacion(state: { presentacion: number }, presentacion: number) {
		state.presentacion = presentacion;
	},
	setRubro(state: { rubro: number }, rubro: number) {
		state.rubro = rubro;
	},
	setSubrubro(state: { subrubro: number }, subrubro: number) {
		state.subrubro = subrubro;
	},
	setLinea(state: { linea: number }, linea: number) {
		state.linea = linea;
	},
	setMarca(state: { marca: number }, marca: number) {
		state.marca = marca;
	},
};
const actions = {
	async addProductoOrden({ commit, dispatch }, producto: { pedido_id: number }): Promise<void> {
		return axios.put('./api/public/proxy/ordenescompra/' + producto['pedido_id'] + '?type=carrito&suma=true', producto).then(response => {
			this.dispatch('loadCarritoOrdenes');
		});
	},
	async removeProductoOrden({ commit, dispatch }, params: Object): Promise<void> {
		return axios.delete('./api/public/proxy/ordenescompra', params).then(response => {
			this.dispatch('loadCarritoOrdenes');
		});
	},
	async removeAllOrden({ commit, dispatch }, params: Object): Promise<void> {
		return axios.delete('./api/public/proxy/ordenescompra', params).then(response => {
			this.dispatch('loadCarritoOrdenes');
			commit('setTotalPedido', 0);
		});
	},
	async putCantidadOrden({ commit, dispatch }, producto: { pedido_id: number }): Promise<void> {
		return axios.put('./api/public/proxy/ordenescompra/' + producto['pedido_id'] + '?type=carrito&suma=false', producto).then(response => {
			this.dispatch('loadCarritoOrdenes');
		});
	},
	async loadProductosOrdenes({ commit, dispatch }, params: Object): Promise<void> {
		return axios.get('./api/public/proxy/ordenescompra', params).then(response => {
			commit('setProductos', response.data.productos as Producto[]);
			commit('setTotal', response.data.total);
		});
	},
	async loadEntitityDataOcompra() {
		try {
			const r = await axios
				.get('./api/public/proxy/cgi/etenet_prodxenti_compras')
				.then(async response => {
					return response.status;
				})
				.catch(() => {});
			return r;
		} catch (error) {
			console.log('ERROR', error);
		}
	},
	async loadCpagos({ commit, dispatch }): Promise<void> {
		return axios.get('./api/public/proxy/ordenescompra?type=cpagos').then(response => {
			commit('setCpagos', response.data.productos);
			return response.data.productos;
		});
	},
	async putCpagoOrdenes({ commit, dispatch }, producto: { pedido_id: number; cpago: number }): Promise<void> {
		commit('setCpago', producto['cpago']);
		return axios
			.put('./api/public/proxy/ordenescompra/' + producto['pedido_id'] + '?type=condiciones&cpago=' + producto['cpago'], producto)
			.then(response => {
				commit('setCpago', producto['cpago']);
				this.dispatch('loadCarritoOrdenes');
			});
	},
	async putDetalleOrdenes({ commit, dispatch }, condicion: { pedido_id: number; detalle: string }): Promise<void> {
		return axios
			.put('./api/public/proxy/ordenescompra/' + condicion['pedido_id'] + '?type=condiciones&detalle=' + condicion['detalle'], condicion)
			.then(response => {
				this.dispatch('loadCarritoOrdenes');
			});
	},
	async putFechaEntregaOrden({ commit, dispatch }, producto: { pedido_id: number; fecha_entrega: number }): Promise<void> {
		commit('setFechaEntrega', producto['fecha_entrega']);
		return axios
			.put(
				'./api/public/proxy/ordenescompra/' + producto['pedido_id'] + '?type=condiciones&fecha_entrega=' + producto['fecha_entrega'],
				producto
			)
			.then(response => {
				commit('setFechaEntrega', producto['fecha']);
				this.dispatch('loadCarritoOrdenes');
			});
	},
	async putConImpuestoOrden({ commit, dispatch }, producto: { pedido_id: number; conimpuesto: boolean }): Promise<void> {
		commit('setConImpuesto', producto['conimpuesto']);
		return axios
			.put('./api/public/proxy/ordenescompra/' + producto['pedido_id'] + '?type=condiciones&conimpuesto=' + producto['conimpuesto'], producto)
			.then(response => {
				commit('setConImpuesto', producto['conimpuesto']);
				this.dispatch('loadCarritoOrdenes');
			});
	},
	async loadCarritoOrdenes({ commit, dispatch }): Promise<void> {
		//commit('setLoadingCarrito', true);
		return axios.get('./api/public/proxy/ordenescompra?type=carrito').then(response => {
			if (!response.data.productos.importes) commit('setTotalPedidos', 0);
			else commit('setTotalPedidos', response.data.productos.importes['importe_total']);
			commit('setCarrito', response.data.productos.productos);
			commit('setCpago', response.data.productos.cpago);
			/*let dias = 0;
			response.data.productos.productos.forEach(element => {
				if (dias < element.dias_de_entrega) dias = element.dias_de_entrega;
			});
			commit('setDiasEntrega', dias);*/
			//TODO: sacar a otro metodo. Lo intente da error distpatch pq no trae parametros.
			let productos = response.data.productos.productos;
			let totales: object[] = [];
			if (productos.length > 0) {
				const countBy = <T extends Record<string, string>, K extends keyof T>(arr: T[], prop: K): Record<string, number> =>
					arr.reduce((prev, curr) => ((prev[curr[prop]] = ++prev[curr[prop]] || 1), prev), {} as Record<string, number>);
				const arra = countBy(productos, 'unimed_venta_completa');
				Object.keys(arra).forEach(element => {
					let suma: number = 0;
					productos.forEach(producto => {
						if (producto.unimed_venta_completa === element) suma = suma + parseInt(producto.cantidad);
					});
					totales.push({
						unimed_venta_completa: element,
						cantidad: suma,
					});
				});
			}
			commit('setTotales', totales);
			commit('setImportes', response.data.productos.importes);
			if (response.data.productos.fecha_entrega) commit('setFechaEntrega', moment(response.data.productos.fecha_entrega).format('DD-MM-yyyy'));
			commit('setConImpuesto', response.data.productos.conimpuesto);
			commit('setIdcarrito', response.data.productos.id);
			commit('setTotalPedido', parseFloat(productos.length > 0 ? response.data.productos.importes.importe_total : 0));
			commit('setDetallePedido', response.data.productos.detalle);
			//commit('setLoadingCarrito', false);
		});
	},
	async confirmOcompra({ commit, dispatch }, idcarrito: number): Promise<void> {
		let config = { params: { pedidoid: idcarrito } };
		return axios.put('./api/public/proxy/ordenescompra', config);
	},
	async loadOrdenesPendientes({ commit, dispatch }, params: { start: number; limit: number }): Promise<void> {
		let config = { params: { pendientes: true } };
		if (params.start === 0) commit('setOrdenesPendientes', []);
		const response = await axios.get(`./api/public/proxy/ordenescompra?start=${params.start}&limit=${params.limit}`, config);
		if (response.data.productos) {
			response.data.productos.forEach(element => {
				commit('setOrdenesPendientes', element);
			});
			return response.data.productos;
		}
	},
	async loadOrdenesAprobados({ commit, dispatch }, params: { start: number; limit: number }) {
		let config = { params: { aprobados: true } };
		if (params.start === 0) commit('setOrdenesAprobados', []);
		const response = await axios.get(`./api/public/proxy/ordenescompra?start=${params.start}&limit=${params.limit}`, config);
		if (response.data.productos) {
			response.data.productos.forEach(element => {
				commit('setOrdenesAprobados', element);
			});
			return response.data.productos;
		}
	},
	async loadOrdenesAplicados({ commit, dispatch }, params: { start: number; limit: number }) {
		let config = { params: { aplicados: true } };
		if (params.start === 0) commit('setOrdenesAplicados', []);
		const response = await axios.get(`./api/public/proxy/ordenescompra?start=${params.start}&limit=${params.limit}`, config);
		if (response.data.productos) {
			response.data.productos.forEach(element => {
				commit('setOrdenesAplicados', element);
			});
			return response.data.productos;
		}
	},
	async loadUnegocioOcompra({ commit, dispatch }): Promise<void> {
		return axios.get('./api/public/proxy/ordenescompra?type=unegocio').then(response => {
			commit('setUnegocio', response.data.productos);
		});
	},
	async loadFamiliaOcompra({ commit, dispatch }, params): Promise<void> {
		return axios
			.get(
				`./api/public/proxy/ordenescompra?type=familia&subfamilia_id=${params.subfamilia_id}
			&rubro_id=${params.rubro_id}&subrubro_id=${params.subrubro_id}&presentacion_id=${params.presentacion_id}`
			)
			.then(response => {
				commit('setFamilia', response.data.productos);
			});
	},
	async loadSubfamiliaOcompra({ commit, dispatch }, params): Promise<void> {
		return axios
			.get(
				`./api/public/proxy/ordenescompra?type=subfamilia&familia_id=${params.familia_id}
			&rubro_id=${params.rubro_id}&subrubro_id=${params.subrubro_id}&presentacion_id=${params.presentacion_id}`
			)
			.then(response => {
				commit('setSubfamilia', response.data.productos);
			});
	},
	async loadPresentacionOcompra({ commit, dispatch }, params): Promise<void> {
		return axios
			.get(
				`./api/public/proxy/ordenescompra?type=presentacion&familia_id=${params.familia_id}
			&rubro_id=${params.rubro_id}&subrubro_id=${params.subrubro_id}&subfamilia_id=${params.subfamilia_id}`
			)
			.then(response => {
				commit('setPresentacion', response.data.productos);
			});
	},
	async loadRubroOcompra({ commit, dispatch }, params): Promise<void> {
		return axios
			.get(
				`./api/public/proxy/ordenescompra?type=rubro&familia_id=${params.familia_id}
			&presentacion_id=${params.presentacion_id}&subrubro_id=${params.subrubro_id}&subfamilia_id=${params.subfamilia_id}`
			)
			.then(response => {
				commit('setRubro', response.data.productos);
			});
	},
	async loadSubrubroOcompra({ commit, dispatch }, params): Promise<void> {
		return axios
			.get(
				`./api/public/proxy/ordenescompra?type=subrubro&familia_id=${params.familia_id}
			&rubro_id=${params.rubro_id}&presentacion_id=${params.presentacion_id}&subfamilia_id${params.subfamilia_id}`
			)
			.then(response => {
				commit('setSubrubro', response.data.productos);
			});
	},
	async loadLineaOcompra({ commit, dispatch }): Promise<void> {
		return axios.get('./api/public/proxy/ordenescompra?type=linea').then(response => {
			commit('setLinea', response.data.productos);
		});
	},
	async loadMarcaOcompra({ commit, dispatch }): Promise<void> {
		return axios.get('./api/public/proxy/ordenescompra?type=marca').then(response => {
			commit('setMarca', response.data.productos);
		});
	},

	reset(): void {
		Object.assign(state, defaultState());
	},
};
export default {
	//namespaced: true,
	state,
	//getters,
	actions,
	mutations,
};
